import React, { useEffect, useState } from "react";
// import EventSignUpInline from "../Home/EventSignUp/EventSignUpInline";
import EventExcerpt from "./EventExcerpt";
import fysee25Logo from "../../Common/_assets/img/fysee25/fyseefalledit-black.png";
// import spinner from "../../Common/_assets/img/placeholder/spinner.gif";
import { listEvents } from "../../utils/api/helpers/event";
// import EventSignUpInline from "../Home/EventSignUp/EventSignUpInline";

const EventList = () => {
	const [eventList, setEventList] = useState(null);
	const [loaded, setLoaded] = useState(null);

	useEffect(() => {
		let subscribed = true;
		if (subscribed && !loaded) {
			setTimeout(() => {
				setLoaded(true);
			}, 1000);

			listEvents().then((result) => {
				// console.log("listEvents", result);
				if (result.data) {
					setEventList(result.data);
				}
			});
		}
		return () => (subscribed = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loaded]);

	return (
		<>
			<div
				className=" events-container width_ctrl nf-sans-cond pt-0 pt-md-5 mb-5 pb-3"
				style={{ marginTop: 75, overflow: "hidden" }}
			>
				<div className="events__grid ">
					<div
						className={"events-grid"}
						style={{ opacity: loaded ? 1 : 0 }}
					>
						<div
							className={
								"events-grid-header justify-content-center"
							}
						>
							<div>
								<img
									src={fysee25Logo}
									className={"fysee25logo"}
									alt={"FYSEE"}
								/>
							</div>
							{/*<div className={"events-grid-tagline"}></div>*/}
						</div>

						{eventList && eventList.length > 0 ? (
							eventList.map((o, i) => {
								return (
									<EventExcerpt
										key={i}
										i={i}
										event_object={o}
									/>
								);
							})
						) : (
							<div
								className={"fw-bold"}
								style={{ fontSize: "2rem", color: "#000" }}
							>
								Check back soon for more events!
							</div>
						)}

						{/*<div*/}
						{/*	className={*/}
						{/*		"mt-4 w-100 nf-sans-cond text-uppercase d-flex align-items-center justify-content-center"*/}
						{/*	}*/}
						{/*	style={{*/}
						{/*		minHeight: "40dvh",*/}
						{/*		textAlign: "center",*/}
						{/*		fontSize: "2rem",*/}
						{/*		fontWeight: 600,*/}
						{/*		color: "#000",*/}
						{/*	}}*/}
						{/*>*/}
						{/*	<EventSignUpInline />*/}
						{/*</div>*/}
					</div>
				</div>
			</div>
			<div className="events__background" />
			<div className="events__background-gradient" />
		</>
	);
};

export default EventList;
